import axios from 'axios'
import Security from './Security'
import { surveillerSessionExpiree } from './SessionExpiree'

class Api {
    static init() {
        return new Promise((resolve, reject) => {
            let secu = new Security();

            secu.isLogged(res => {
                if (res) {
                    localforage
                        .getItem('api-token')
                        .then(key => {

                            let params = {
                                baseURL: urlAPI,
                                headers: {
                                    'Authorization': 'Bearer ' + key,
                                }
                            };

                            let api = surveillerSessionExpiree(axios.create(params));
                            resolve(api)
                        }).catch(err => reject(err))
                } else {
                    reject('Pas connecté !')
                }
            })
        })
    }
}

export default Api



// WEBPACK FOOTER //
// ./src/js/core/Api.js